import React from 'react'
import './ServicesStyles.css'

const Services = () => {
  return (
    <div className="services">
        <div className="left">
            <img src="https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80" alt="" />
        </div>
        <div className="right">
          <h1>What we do:</h1>
            <p>Our mechanics can perform all auto repair and maintenance tasks, from major repairs to oil changes.  If your vehicle ever breaks down, don’t panic! Our towing service will come and get you. We aim to be the best auto repair shop in Roslindale!</p>
            <p>Just give us a call at +1 (617) 792-7476</p>
        </div>
    </div>
  )
}

export default Services